import Storage from '../Storage.js';

Storage.setTranslations("en", {

  menu_exit: "Exit",

  title_create: "Create",
  title_edit: "Edit",
  title_view: "View",
  
  button_search: "Search",
  button_edit: "Edit",
  button_delete: "Delete",
  button_add: "Add",
  button_save: "Save",
  button_deleted: "Deleted",
  button_close: "Close",
  button_cancel: "Cancel",

  page_previous: "previous",
  page_next: "next",
  page_placeholder: "page",
  page_go: "go",

  input_select: "Select...",
  input_enter: "Enter name...",
  
  display_yes: "yes",
  display_no: "no",

  modal_response_title: "Server response",
  modal_response_link: "Download link",
  modal_delete_title: "DELETE",
  modal_delete_text: "Are you sure want to delete ",
  
});


// WEBPACK FOOTER //
// ./src/translations/en.js